import { Skeleton } from '../../../../Skeleton'
import { PHASE_STRIP_SKELETON_ROW_COUNT } from '../../RentalPortalPhaseBar.constants'

import * as styles from './PhaseStripSkeleton.module.css'

function PhaseStripSkeleton() {
  return Array.from({ length: PHASE_STRIP_SKELETON_ROW_COUNT }).map(
    (_, index) => <Skeleton className={styles.row} key={index} />
  )
}

export default PhaseStripSkeleton
